export class UpdateInwardDataIds {
    productHeaderIdList: number[] = [];
}

